module.exports = __webpack_public_path__ + "img/desk4.44a303fa.png";